import React from 'react';
import { CtaButton } from './CtaButton';
import { PRICE, PRODUCT_NAME, SUPPORT_EMAIL } from '../data/offer';
export function FinalCta() {
  return <section className="w-full bg-carbon-800 py-16 sm:py-20 lg:py-28" aria-labelledby="final-heading" data-id="element-97" data-mp="vh0scm59e1tj">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-98" data-mp="15ddhd6puzrhy">
        <h2 id="final-heading" className="display-tight font-display text-[36px] uppercase text-paper sm:text-[64px]" data-id="element-99" data-mp="15bspxpyucoob">
          Stop improvising.
          <span className="block text-mint" data-id="element-100" data-mp="1ed0n24pmfjgt">Start leading.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-paper-dim sm:mt-6 sm:text-lg" data-id="element-101" data-mp="1t3g4r9itw9a8">
          Get instant access to all 6 PDFs and start your professional transformation today.
        </p>
        <div className="mt-10 flex justify-center" data-id="element-102" data-mp="222uyqiy7f1zh">
          <CtaButton size="lg" note="Secure checkout — instant PDF download" data-id="element-103" data-mp="221a1glki94xx">
            Yes! I want the pack — {PRICE}
          </CtaButton>
        </div>
        <p className="mt-6 text-sm text-paper-dim" data-id="element-104" data-mp="n6nr2ye1q4ws">
          Protected by our 10-day money-back guarantee.
        </p>
      </div>
    </section>;
}
export function PageFooter() {
  return <footer className="w-full border-t border-carbon-line bg-carbon-900 py-10" data-id="element-105" data-mp="x2qu06gq27ks">
      <div className="mx-auto flex max-w-content flex-col items-center justify-between gap-3 px-4 text-center text-xs text-paper-dim sm:flex-row sm:px-6 sm:text-left" data-id="element-106" data-mp="123elet8v4qfj">
        <p className="font-display uppercase tracking-[0.16em] text-paper" data-id="element-107" data-mp="162m9uol82qr5">{PRODUCT_NAME}</p>
        <p data-id="element-108" data-mp="1b1guzx6nwref">
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-mint underline underline-offset-4 transition-colors duration-150 ease-out hover:text-paper" data-id="element-109" data-mp="1ftqfuysx719u">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p data-id="element-110" data-mp="1puaju97tqjvr">© {new Date().getFullYear()} — Digital PDF product. Instant delivery worldwide.</p>
      </div>
    </footer>;
}